import actions from './actions'
import mutations from './mutations'
import getters from './getters'

const state = {
  reviewProject: { reviewTimeLine: [] },
  projectsRebuttals: [],
  rebuttalsNotifications: [],
  codeTypeList: [],
  projectsRebuttalsBackup: []
}

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
